<template>
  <div
    v-if="companyLogin"
    id="main"
    :class="companyCssClass"
  >
    <ife-row
      align-h="center"
    >
      <ife-col
        cols="12"
        md="6"
        lg="5"
        xl="3"
        class="mt-4 text-center"
      >
        <showcase-company-logo width="220px" />
        <b-overlay :show="states.login.loading">
          <div
            id="login-card"
            class="p-3"
            :class="`text-center ${companyCssClass}`"
          >
            <b-alert
              variant="danger"
              :show="states.login.error !== null"
            >
              {{ states.login.error }}
            </b-alert>

            <validation-observer v-slot="v">
              <ife-form
                ref="loginForm"
                :validation-summary="false"
                @submit="v.handleSubmit(login)"
              >
                <ife-simple-input
                  v-model="credentials.email"
                  :label-cols="4"
                  hide-label
                  label="Email Address"
                  type="email"
                  placeholder="Email address"
                  rules="required"
                />

                <ife-simple-input
                  v-model="credentials.password"
                  :label-cols="4"
                  hide-label
                  label="Password"
                  type="password"
                  placeholder="Password"
                  rules="required"
                />

                <img
                  v-if="isUsingImageButton"
                  alt="Company Logo"
                  :class="`button ${companyLogin.cssClass}`"
                  src="@/assets/img/btn/ato-login.svg"
                  @click="$refs.loginForm.submit()"
                >
                <b-btn
                  v-show="!isUsingImageButton"
                  size="sm"
                  variant="primary"
                  type="submit"
                  :class="companyLogin.cssClass"
                >
                  Log In
                </b-btn>
              </ife-form>
            </validation-observer>
            <login-links />
          </div>

          <template #overlay>
            <div class="text-center">
              <b-icon
                icon="shield-lock"
                font-scale="3"
                animation="cylon"
              />
              <p id="label">
                Authenticating
              </p>
            </div>
          </template>
        </b-overlay>
      </ife-col>
    </ife-row>
  </div>
</template>

<script>
import CompanyLoginMixin from '@/Client/Mixin/CompanyLogin';
import {InitStore} from '@/Client/Store';
import LoginLinks from '@/Client/Component/Common/LoginLinks.vue';
import ShowcaseCompanyLogo from '@/Client/Page/ShowcaseCompanyLogo.vue';

export default {
  name: 'CompanyLogin',
  components: {
    LoginLinks,
    ShowcaseCompanyLogo,
  },
  mixins: [CompanyLoginMixin],
  data() {
    return {
      credentials: {
        companyId: null,
        email: null,
        password: null,
      },
      states: {
        login: {
          loading: false,
          error: null,
        },
      },
    };
  },
  computed: {
    isUsingImageButton() {
      return 'atallorder' === this.companyLogin.name;
    },
  },
  mounted() {
    if (null === this.companyLogin) {
      this.$router.push({name: 'login'});
    }

    this.credentials.companyId = this.companyLogin.id;

    if (this.companyLogin.windowTitle) {
      document.title = this.companyLogin.windowTitle;
    }

    if ('undefined' !== typeof this.companyLogin.favicon) {
      this.setFavicon(require('../../../assets/img/favicon/' + this.companyLogin.favicon));
    }
  },
  methods: {
    login() {
      this.states.login.error = null;
      this.states.login.loading = true;
      this.$store.dispatch(
          'login',
          this.credentials,
      ).then(() => {
        InitStore.init(this.axios, this.$store);
        this.$router.push({name: this.companyLogin.route, params: {id: this.companyLogin.id}});
      }).catch((error) => {
        this.$log.error(error);
        this.states.login.loading = false;
        this.states.login.error = 'Invalid email or password';
      });
    },
  },
};
</script>

<style scoped>
  #main {
    background-attachment: fixed;
    height: 100vh;
  }

  .button:hover {
    cursor: pointer;
  }
</style>
